import {useNavigate } from "react-router-dom"
import { useContext,useEffect,useState } from "react";
import MyContext from "../../context/Context";
import Loader from "../Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { addToCart, deleteFromCart } from "../../redux/cartSlice";
import { DLT,ADD,REMOVE } from '../../redux/Actions/action'
import { collection,orderBy,onSnapshot, getDocs, query, where } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";


const Homeproduct = () => {

    const navigate = useNavigate();
    
    const context = useContext(MyContext);

    const [loading, setLoading] = useState(false);

    const cartItems = useSelector((state) => state.cartreducer.carts);
 
    const dispatch = useDispatch();
    const [deliveredProducts, setDeliveredProducts] = useState({});
 
    const addCart = (item) => {
        dispatch(ADD(item));
        toast.success("Add to cart")
    }

    const deleteCart = (item) => {
        dispatch(deleteFromCart(item));
        toast.success("Delete cart")
    }

    
    const handleProductClick = (product) => {
        // Get the existing last visited products from localStorage
        let lastVisitedProducts = JSON.parse(localStorage.getItem("lastVisitedProducts")) || [];
    
        // Check if the product already exists in the list (to prevent duplicates)
        lastVisitedProducts = lastVisitedProducts.filter(p => p.id !== product.id);
    
        // Add the new product at the beginning of the array
        lastVisitedProducts.unshift(product);
    
        // Keep only the last 5 products
        lastVisitedProducts = lastVisitedProducts.slice(0,8);
    
        // Store back in localStorage
        localStorage.setItem("lastVisitedProducts", JSON.stringify(lastVisitedProducts));
    
        // Navigate to product info page
        navigate(`/productinfo/${product.id}`);
    };
    
    const [getAllProduct,setGetAllProduct] = useState([]);

    /**========================================================================
     *========================================================================**/
    
    const getAllProductFunction = async () => {
        setLoading(true);
        try {
            const q = query(
                collection(fireDB, "products"),
                where("featured", "==", true) // Only fetch approved products
            );
            const data = onSnapshot(q, (QuerySnapshot) => {
                let productArray = [];
                QuerySnapshot.forEach((doc) => {
                    productArray.push({ ...doc.data(), id: doc.id });
                });
                setGetAllProduct(productArray);
                setLoading(false);
            });
            return () => data;
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }
    

    useEffect(() => {
        localStorage.setItem('cart',JSON.stringify(cartItems));
        getAllProductFunction()
    }, [cartItems])

    // Fetch delivered orders
    const getDeliveredOrders = async () => {
        try {
            const q = query(collection(fireDB, "order"), where("status", "==", "delivered"));
            const querySnapshot = await getDocs(q);
            const deliveredItems = {};

            querySnapshot.forEach((doc) => {
                const orderData = doc.data();
                orderData.cartItems.forEach((item) => {
                    deliveredItems[item.id] = true; // Mark product as delivered
                });
            });

            setDeliveredProducts(deliveredItems);
        } catch (error) {
            console.log(error);
            toast.error("Failed to load orders");
            
        }
    };

    useEffect(() => {
      
        getDeliveredOrders()
    }, []);
    

    return (
        <div className="mt-16">
         


            <section className="text-gray-600 body-font">
         
  <div className=" px-5 py-5">
    <div className="flex flex-wrap justify-center">
      
      {getAllProduct.slice(0,8).map((item, index) => {
        const { id, title, price, productImageUrl, reviews, discount } = item;

        const images = Array.isArray(productImageUrl)
          ? productImageUrl
          : productImageUrl
          ? [productImageUrl]
          : [];

        return (
          <div key={index} className="p-3 ">
              {/* Heading  */}
              <div className="">
                <h1 className=" text-center font-poppins mb-6 text-black md:text-3xl text-2xl font-semibold">
                Featured Products</h1>
            </div>
            <div className="relative  bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
              
              {/* Discount Badge */}
              {discount && (
                <div className="absolute top-2 left-2 bg-yellow-400 text-xs font-semibold px-2 py-1 rounded">
                  {discount}% OFF
                </div>
              )}

              {/* Product Image */}
              <div className="flex justify-center bg-white ">
                                            {images?.[0] && (
                                                <img
                                                    src={images[0]}
                                                    alt="Product"
                                                    onClick={() => handleProductClick(item)}
                                                    className="card h-[280px] w-[300px] object-cover cursor-pointer"
                                                />
                                            )}
                                        </div>

              {/* Product Info */}
              <div className="p-4 text-center">
                <h2 className="text-xs font-poppins text-gray-500 mb-1 uppercase tracking-wider">Durapot</h2>
                <h1 className="text-lg font-outfit font-medium text-gray-900 mb-2">
                  {title.substring(0, 25)}
                </h1>

                {/* Price Display */}
                <div className="flex justify-center items-center space-x-2 mb-2">
                                                <span className="text-gray-500 line-through  font-outfit text-lg font-medium">
                                                    ₹{Math.round(price * 1.10)}
                                                </span>
                                                <span className="text-green-700 italic  font-outfit text-lg font-medium">₹{price}</span>
                                            </div>

                {/* Review Display */}
                {reviews && (
                  <div className="flex justify-center items-center text-sm text-green-700 mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="w-4 h-4 mr-1"
                      viewBox="0 0 20 20"
                    >
                      <path d="M10 15l-5.878 3.09 1.122-6.545L.488 6.91l6.561-.954L10 0l2.951 5.956 6.561.954-4.756 4.635 1.122 6.545z" />
                    </svg>
                    <span>{reviews.rating} ({reviews.count} Reviews)</span>
                  </div>
                )}

                {/* Action Button */}
                <button
                  onClick={() => handleProductClick(item)}
                  className="w-full py-2 rounded-lg bg-green-600 hover:bg-green-700 font-semibold font-outfit text-white"
                >
                  View Product
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
</section>

        </div>
    );
}

export default Homeproduct;